import React, { useState, useRef, useEffect } from "react";
import { PaperPlaneRight, X, ChatCircleDots } from "@phosphor-icons/react";

export function RideChat({ messages, myId, otherName, onSend, onClose }) {
  const [text, setText] = useState("");
  const endRef = useRef(null);

  useEffect(() => { endRef.current?.scrollIntoView({ behavior: "smooth" }); }, [messages.length]);

  const submit = (e) => {
    e.preventDefault();
    const t = text.trim();
    if (!t) return;
    onSend(t);
    setText("");
  };

  return (
    <div className="absolute inset-0 z-[1200] bg-slate-900/50 flex items-end justify-center" data-testid="ride-chat">
      <div className="bg-white w-full max-w-md rounded-t-3xl flex flex-col slide-up" style={{ height: "70vh" }}>
        <div className="flex items-center justify-between px-5 py-4 border-b border-slate-100">
          <div className="flex items-center gap-2">
            <ChatCircleDots size={22} weight="duotone" style={{ color: "var(--primary)" }} />
            <h3 className="font-display font-bold text-lg">{otherName || "Chat"}</h3>
          </div>
          <button onClick={onClose} className="w-9 h-9 rounded-full bg-slate-100 flex items-center justify-center" data-testid="chat-close-btn"><X size={18} /></button>
        </div>
        <div className="flex-1 overflow-auto px-4 py-3 space-y-2 scroll-area" data-testid="chat-messages">
          {messages.length === 0 && <p className="text-slate-400 text-sm text-center py-8">Aún no hay mensajes. ¡Saluda!</p>}
          {messages.map((m) => {
            const mine = m.sender_id === myId;
            return (
              <div key={m.id} className={`flex ${mine ? "justify-end" : "justify-start"}`} data-testid={`chat-msg-${m.id}`}>
                <div className={`max-w-[75%] px-3 py-2 rounded-2xl text-sm ${mine ? "rounded-br-sm text-white" : "rounded-bl-sm bg-slate-100 text-slate-800"}`} style={mine ? { background: "var(--primary)" } : {}}>
                  {m.text}
                </div>
              </div>
            );
          })}
          <div ref={endRef} />
        </div>
        <form onSubmit={submit} className="p-3 border-t border-slate-100 flex gap-2">
          <input value={text} onChange={(e) => setText(e.target.value)} className="input-field flex-1" placeholder="Escribe un mensaje..." data-testid="chat-input" />
          <button type="submit" className="btn-primary px-4" data-testid="chat-send-btn"><PaperPlaneRight size={18} weight="fill" /></button>
        </form>
      </div>
    </div>
  );
}
